<div class="row">
  <inspection-model-new
    [processing]="processing"
    [showSubTypes]="showSubTypes"
    (toggleSaveInspection)="saveInspection($event)"
    (toggleCancel)="cancel()"
  ></inspection-model-new>
</div>
